/** Boot art is exactly the local world identity plus the FIRST full roster.
 * Later arrivals are lazy assets, not retroactive changes to a boot metric. */
export class InitialModelCohort {
  constructor({ ids, onSettled }) {
    this.allowed = new Set(ids);
    this.onSettled = onSettled;
    this.local = null;
    this.roster = null;
    this.settled = false;
  }
  setLocal(id) { this.local ??= id; }
  setRoster(ids) {
    this.roster ??= [...new Set(ids)].filter(id => this.allowed.has(id));
  }
  update(states) {
    if (this.settled || this.local == null || this.roster == null) return;
    const ids = [...new Set([this.local, ...this.roster])].filter(id => this.allowed.has(id));
    const cohortStates = Object.fromEntries(ids.map(id => [id, states[id] ?? 'not-requested']));
    if (Object.values(cohortStates).some(state => !['ready', 'failed', 'timeout'].includes(state))) return;
    this.settled = true;
    this.onSettled({ cohort: 'local-identity-and-first-roster', ready: Object.values(cohortStates).every(state => state === 'ready'), states: cohortStates });
  }
}
